import { atom } from 'recoil';

export type Collection = {
  id: string;
  data: {
    retrofits: string[];
    ships: string[];
  };
};

export const collectionState = atom<Collection | null>({
  key: 'collectionState',
  default: null,
});
